// See webpack.config.js for details.
window['Vue'] = require('vue');
window['limitTimer'] = null;
var VueRouter = require('vue-router'),
	Enter = Vue.extend(require('./enter.vue')),
	Router = new VueRouter({
		hashbang: true
	});
Vue.use(VueRouter);

//路由表
Router.map({
	'/index': {
		component: function(resolve) {
			require(['./components/index/index.vue'], resolve)
		},
		subRoutes: {
			'/notice': {
				back: true,
				component: function(resolve) {
					require(['./components/find/notice.vue'], resolve)
				},
				subRoutes: {
					'/detail': {
						back: true,
						component: function(resolve) {
							require(['./components/find/detail.vue'], resolve)
						}
					}
				}
			},
			'/team': {
				back: true,
				component: function(resolve) {
					require(['./components/find/team.vue'], resolve)
				}
			},
			'/holder': {
				back: true,
				component: function(resolve) {
					require(['./components/find/holder.vue'], resolve)
				}
			},
			'/product': {
				back: true,
				component: function(resolve) {
					require(['./components/find/product.vue'], resolve)
				}
			},
			'/security': {
				back: true,
				component: function(resolve) {
					require(['./components/find/security.vue'], resolve)
				}
			},
			'/bankdeposit': {
				back: true,
				component: function(resolve) {
					require(['./components/find/bankdeposit.vue'], resolve)
				},
				subRoutes: {
					'/bankdepositword': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositword.vue'], resolve)
						}
					},
					'/bankdepositpic': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic.vue'], resolve)
						}
					}
				}
			},
			'/bankdepositpic': {
				back: true,
				component: function(resolve) {
					require(['./components/find/bankdepositpic.vue'], resolve)
				}
			},
			'/bankdepositpic5': {
				back: true,
				component: function(resolve) {
					require(['./components/find/bankdepositpic5.vue'], resolve)
				}
			},
			'/bankdepositpic3': {
				back: true,
				component: function(resolve) {
					require(['./components/find/bankdepositpic3.vue'], resolve)
				}
			},
			'/bankdepositpic4': {
				back: true,
				component: function(resolve) {
					require(['./components/find/bankdepositpic4.vue'], resolve)
				}
			},
			'/intro': {
				back: true,
				component: function(resolve) {
					require(['./components/index/intro.vue'], resolve)
				}
			},
			'/invest': {
				limits: 'bankdeposit',
				back: true,
				component: function(resolve) {
					require(['./components/pay/invest.vue'], resolve)
				},
				subRoutes: {
					'/confirm': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/confirm.vue'], resolve)
						},
						subRoutes: {
							'/success': {
								back: '/user',
								component: function(resolve) {
									require(['./components/pay/success.vue'], resolve)
								}
							},
							'/charge': {
								back: true,
								component: function(resolve) {
									require(['./components/contract/charge.vue'], resolve)
								},
								subRoutes: {
									'/focus': {
										back: true,
										component: function(resolve) {
											require(['./components/contract/focus.vue'], resolve)
										},
										subRoutes: {
											'/contract': {
												back: true,
												component: function(resolve) {
													require(['./components/public/contract.vue'], resolve)
												}
											}
										}
									}
								}
							},
							'/contract': {
								back: true,
								component: function(resolve) {
									require(['./components/public/contract.vue'], resolve)
								}
							},
							'/appraisal': {
								back: true,
								component: function(resolve) {
									require(['./components/appraisal/appraisal.vue'], resolve)
								}
							},
							'/type': {
								back: true,
								component: function(resolve) {
									require(['./components/products/type.vue'], resolve)
								},
								subRoutes: {
									'/view': {
										back: true,
										component: function(resolve) {
											require(['./components/products/view.vue'], resolve)
										},
										subRoutes: {
											'/contract': {
												back: true,
												component: function(resolve) {
													require(['./components/public/contract.vue'], resolve)
												}
											},
											'/charge': {
												back: true,
												component: function(resolve) {
													require(['./components/contract/charge.vue'], resolve)
												}
											},
											'/success': {
												back: '/user',
												component: function(resolve) {
													require(['./components/pay/success.vue'], resolve)
												}
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	},
	'/user': {
		component: function(resolve) {
			require(['./components/user/user.vue'], resolve)
		},
		subRoutes: {
			'/withdraw': {
				limits: 'bankdeposit',
				back: true,
				component: function(resolve) {
					require(['./components/withdraw/withdraw.vue'], resolve)
				},
				subRoutes: {
					'/assets': {
						limits: 'bankdeposit',
						back: true,
						component: function(resolve) {
							require(['./components/withdraw/assets.vue'], resolve)
						},
						subRoutes: {
							'/contract': {
								component: function(resolve) {
									require(['./components/public/contract.vue'], resolve)
								}
							},
							'/finish': {
								back: '/user',
								component: function(resolve) {
									require(['./components/withdraw/finish.vue'], resolve)
								}
							},
							'/assetsing': {
								back: '/user',
								component: function(resolve) {
									require(['./components/withdraw/assetsing.vue'], resolve)
								}
							}
						}
					},
					'/banking': {
						component: function(resolve) {
							require(['./components/system/banking.vue'], resolve)
						}
					}
				}
			},
			'/assets': {
				limits: 'bankdeposit',
				back: true,
				component: function(resolve) {
					require(['./components/withdraw/assets.vue'], resolve)
				},
				subRoutes: {
					'/finish': {
						back: '/user',
						component: function(resolve) {
							require(['./components/withdraw/finish.vue'], resolve)
						}
					},
					'/assetsing': {
						back: '/user',
						component: function(resolve) {
							require(['./components/withdraw/assetsing.vue'], resolve)
						}
					},
					'/contract': {
						component: function(resolve) {
							require(['./components/public/contract.vue'], resolve)
						}
					}
				}
			},
			'/mobiles': {
				// limits: 'bankdeposit',
				// skipsign: true,
				back: true,
				component: function(resolve) {
					require(['./components/pay/mobiles.vue'], resolve)
				},
				subRoutes: {
					'/bankdepositword': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositword.vue'], resolve)
						}
					},
					'/ccb': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/recharge/ccb.vue'], resolve)
						}
					},
					'/abc': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/recharge/abc.vue'], resolve)
						}
					},
					'/icbc': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/recharge/icbc.vue'], resolve)
						}
					},
					'/boc': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/recharge/boc.vue'], resolve)
						}
					},
					'/cmb': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/recharge/cmb.vue'], resolve)
						}
					},
					'/cmsb': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/recharge/cmsb.vue'], resolve)
						}
					},
					'/pabc': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/recharge/pabc.vue'], resolve)
						}
					},
					'/other': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/recharge/other.vue'], resolve)
						}
					}
				}
			},
			'/fast': {
				limits: 'bankdeposit',
				skipsign: true,
				back: true,
				component: function(resolve) {
					require(['./components/pay/fasts.vue'], resolve)
				},
				subRoutes: {
					'/auth': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/auth.vue'], resolve)
						},
						subRoutes: {
							'/finish': {
								back: '/user',
								component: function(resolve) {
									require(['./components/pay/finish.vue'], resolve)
								}
							}
						}
					},
					'/mobiles': {
						// limits: 'bankdeposit',
						// skipsign: true,
						back: true,
						component: function(resolve) {
							require(['./components/pay/mobiles.vue'], resolve)
						},
						subRoutes: {
							'/bankdepositword': {
								back: true,
								component: function(resolve) {
									require(['./components/find/bankdepositword.vue'], resolve)
								}
							},
							'/ccb': {
								back: true,
								component: function(resolve) {
									require(['./components/pay/recharge/ccb.vue'], resolve)
								}
							},
							'/abc': {
								back: true,
								component: function(resolve) {
									require(['./components/pay/recharge/abc.vue'], resolve)
								}
							},
							'/icbc': {
								back: true,
								component: function(resolve) {
									require(['./components/pay/recharge/icbc.vue'], resolve)
								}
							},
							'/boc': {
								back: true,
								component: function(resolve) {
									require(['./components/pay/recharge/boc.vue'], resolve)
								}
							},
							'/cmb': {
								back: true,
								component: function(resolve) {
									require(['./components/pay/recharge/cmb.vue'], resolve)
								}
							},
							'/other': {
								back: true,
								component: function(resolve) {
									require(['./components/pay/recharge/other.vue'], resolve)
								}
							}
						}
					},
					'/banking': {
						component: function(resolve) {
							require(['./components/system/banking.vue'], resolve)
						}
					}
				}
			},
			'/invest': {
				limits: 'bankdeposit',
				back: true,
				component: function(resolve) {
					require(['./components/pay/invest.vue'], resolve)
				},
				subRoutes: {
					'/confirm': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/confirm.vue'], resolve)
						},
						subRoutes: {
							'/success': {
								back: '/user',
								component: function(resolve) {
									require(['./components/pay/success.vue'], resolve)
								}
							},
							'/charge': {
								back: true,
								component: function(resolve) {
									require(['./components/contract/charge.vue'], resolve)
								},
								subRoutes: {
									'/focus': {
										back: true,
										component: function(resolve) {
											require(['./components/contract/focus.vue'], resolve)
										},
										subRoutes: {
											'/contract': {
												back: true,
												component: function(resolve) {
													require(['./components/public/contract.vue'], resolve)
												}
											}
										}
									}
								}
							},
							'/contract': {
								back: true,
								component: function(resolve) {
									require(['./components/public/contract.vue'], resolve)
								}
							},
							'/appraisal': {
								back: true,
								component: function(resolve) {
									require(['./components/appraisal/appraisal.vue'], resolve)
								}
							},
							'/type': {
								back: true,
								component: function(resolve) {
									require(['./components/products/type.vue'], resolve)
								},
								subRoutes: {
									'/view': {
										back: true,
										component: function(resolve) {
											require(['./components/products/view.vue'], resolve)
										},
										subRoutes: {
											'/contract': {
												back: true,
												component: function(resolve) {
													require(['./components/public/contract.vue'], resolve)
												}
											},
											'/charge': {
												back: true,
												component: function(resolve) {
													require(['./components/contract/charge.vue'], resolve)
												}
											},
											'/success': {
												back: '/user',
												component: function(resolve) {
													require(['./components/pay/success.vue'], resolve)
												}
											}
										}
									}
								}
							}
						}
					}
				}

			},
			'/paying': {
				back: '/user',
				component: function(resolve) {
					require(['./components/pay/paying.vue'], resolve)
				}
			},
			'/assetsing': {
				back: '/user',
				component: function(resolve) {
					require(['./components/withdraw/assetsing.vue'], resolve)
				}
			},
			'/withdrawing': {
				back: '/user',
				component: function(resolve) {
					require(['./components/withdraw/withdrawing.vue'], resolve)
				}
			},
			'/record': {
				back: true,
				component: function(resolve) {
					require(['./components/account/record.vue'], resolve)
				},
				subRoutes: {
					'/contract': {
						back: true,
						component: function(resolve) {
							require(['./components/public/contract.vue'], resolve)
						}
					}
				}
			},
			'/profit': {
				back: true,
				component: function(resolve) {
					require(['./components/account/profit.vue'], resolve)
				},
				subRoutes: {
					'/profittxt': {
						back: true,
						component: function(resolve) {
							require(['./components/account/profittxt.vue'], resolve)
						}
					}
				}
			},
			'/userassets': {
				back: true,
				component: function(resolve) {
					require(['./components/account/assets.vue'], resolve)
				},
				subRoutes: {
					'/assetslist': {
						back: true,
						component: function(resolve) {
							require(['./components/account/assetslist.vue'], resolve)
						},
						subRoutes: {
							'/view': {
								back: true,
								component: function(resolve) {
									require(['./components/product/view.vue'], resolve)
								},
								subRoutes: {
									'/contract': {
										back: true,
										component: function(resolve) {
											require(['./components/public/contract.vue'], resolve)
										}
									}
								}
							},
							'payplan': {
								back: true,
								component: function(resolve) {
									require(['./components/account/payplan.vue'], resolve)
								},
								subRoutes: {
									'/view': {
										back: true,
										component: function(resolve) {
											require(['./components/product/view.vue'], resolve)
										},
										subRoutes: {
											'/contract': {
												back: true,
												component: function(resolve) {
													require(['./components/public/contract.vue'], resolve)
												}
											}
										}
									},
									'/payplantxt': {
										back: true,
										component: function(resolve) {
											require(['./components/account/payplantxt.vue'], resolve)
										}
									}
								}
							},
							'/realize': {
								back: true,
								component: function(resolve) {
									require(['./components/account/realize.vue'], resolve)
								},
								subRoutes: {
									'/contract': {
										back: true,
										component: function(resolve) {
											require(['./components/public/contract.vue'], resolve)
										}
									}
								}
							},
							'/contract': {
								back: true,
								component: function(resolve) {
									require(['./components/public/contract.vue'], resolve)
								}
							},
							'/contractlist': {
								back: true,
								component: function(resolve) {
									require(['./components/account/contractlist.vue'], resolve)
								},
								subRoutes: {
									'/contract': {
										back: true,
										component: function(resolve) {
											require(['./components/public/contract.vue'], resolve)
										}
									}
								}
							}
						}
					},
					'/assetsdetails': {
						back: true,
						component: function(resolve) {
							require(['./components/account/assetsdetails.vue'], resolve)
						},
						subRoutes: {
							'/assetstxt': {
								back: true,
								component: function(resolve) {
									require(['./components/account/assetstxt.vue'], resolve)
								}
							}
						}
					}
				}
			},
			'/experience': {
				back: true,
				component: function(resolve) {
					require(['./components/account/experience.vue'], resolve)
				},
				subRoutes: {
					'/experiencetxt': {
						back: true,
						component: function(resolve) {
							require(['./components/account/experiencetxt.vue'], resolve)
						}
					}
				}
			},
			'/inrate': {
				back: true,
				component: function(resolve) {
					require(['./components/account/inrate.vue'], resolve)
				},
				subRoutes: {
					'/inratetxt': {
						back: true,
						component: function(resolve) {
							require(['./components/account/inratetxt.vue'], resolve)
						}
					}
				}
			},
			'/cash': {
				back: true,
				component: function(resolve) {
					require(['./components/account/cash.vue'], resolve)
				},
				subRoutes: {
					'/cashtxt': {
						back: true,
						component: function(resolve) {
							require(['./components/account/cashtxt.vue'], resolve)
						}
					}
				}
			},
			'/vip': {
				back: true,
				component: function(resolve) {
					require(['./components/account/vips.vue'], resolve)
				},
				subRoutes: {
					'/lottery': {
						back: true,
						component: function(resolve) {
							require(['./components/account/lottery.vue'], resolve)
						},
						subRoutes: {
							'/lotteryrule': {
								back: true,
								component: function(resolve) {
									require(['./components/account/lotteryrule.vue'], resolve)
								}
							},
							'/lotteryhelp': {
								back: true,
								component: function(resolve) {
									require(['./components/account/lotteryhelp.vue'], resolve)
								}
							},
							'/lotterylist': {
								back: true,
								component: function(resolve) {
									require(['./components/account/lotterylist.vue'], resolve)
								}
							}
						}
					},
					'/signin': {
						back: true,
						component: function(resolve) {
							require(['./components/account/signin.vue'], resolve)
						},
						subRoutes: {
							'/questions': {
								back: true,
								component: function(resolve) {
									require(['./components/questions/questions.vue'], resolve)
								}
							},
							'/share': {
								back: true,
								component: function(resolve) {
									require(['./components/public/share.vue'], resolve)
								}
							}
						}
					},
					'/invite': {
						back: true,
						component: function(resolve) {
							require(['./components/account/invite.vue'], resolve)
						},
						subRoutes: {
							'/invitelist': {
								back: true,
								component: function(resolve) {
									require(['./components/account/invitelist.vue'], resolve)
								}
							},
							'/cash': {
								back: true,
								component: function(resolve) {
									require(['./components/account/cash.vue'], resolve)
								}
							},
							'/inviterule': {
								back: true,
								component: function(resolve) {
									require(['./components/account/inviterule.vue'], resolve)
								}
							}
						}
					},
					'/leval': {
						back: true,
						component: function(resolve) {
							require(['./components/account/vip.vue'], resolve)
						},
						subRoutes: {
							'/lotterylist': {
								back: true,
								component: function(resolve) {
									require(['./components/account/lotterylist.vue'], resolve)
								}
							},
							'/viprule': {
								back: true,
								component: function(resolve) {
									require(['./components/account/viprule.vue'], resolve)
								}
							},
							'/appraisal': {
								back: true,
								component: function(resolve) {
									require(['./components/appraisal/appraisal.vue'], resolve)
								}
							}
						}
					},
					'/groups': {
						back: true,
						component: function(resolve) {
							require(['./components/group/group.vue'], resolve)
						}
					}
				}
			},
			'/inovances': {
				back: '/user',
				component: function(resolve) {
					require(['./components/activity/inovances.vue'], resolve)
				}
			}
		}
	},
	'/retreat':{
		component: function(resolve) {
			require(['./components/retreat/retreat.vue'], resolve)
		},
		subRoutes: {
			'/inovance': {
				back: true,
				component: function(resolve) {
					require(['./components/public/view.vue'], resolve)
				}
			},
			'/withdraw': {
				limits: 'bankdeposit',
				back: true,
				component: function(resolve) {
					require(['./components/retreat/withdraw.vue'], resolve)
				},
				subRoutes: {
					'/banking': {
						component: function(resolve) {
							require(['./components/system/banking.vue'], resolve)
						}
					}
				}
			},
			'/notice': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/notice.vue'], resolve)
				}
			},
			'/guide': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/guide.vue'], resolve)
				},
				subRoutes: {
					'/word': {
						component: function(resolve) {
							require(['./components/retreat/word.vue'], resolve)
						}
					}
				}
			},
			'/help': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/help.vue'], resolve)
				}
			},
			'/platform': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/platform.vue'], resolve)
				},
				subRoutes: {
					'/siteplan': {
						component: function(resolve) {
							require(['./components/retreat/siteplan.vue'], resolve)
						}
					}
				}
			},
			'/capital': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/capital.vue'], resolve)
				}
			},
			'/plan': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/plan.vue'], resolve)
				}
			},
			'/word': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word.vue'], resolve)
				}
			},
			'/word2': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word2.vue'], resolve)
				}
			},
			'/word3': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word3.vue'], resolve)
				}
			},
			'/word5': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word5.vue'], resolve)
				}
			},
			'/word6': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word6.vue'], resolve)
				}
			},
			'/word7': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word7.vue'], resolve)
				}
			},
			'/word9': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word9.vue'], resolve)
				}
			},
			'/word10': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word10.vue'], resolve)
				}
			},
			'/word11': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word11.vue'], resolve)
				}
			},
			'/word12': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word12.vue'], resolve)
				}
			},
			'/word13': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word13.vue'], resolve)
				}
			},
			'/word14': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word14.vue'], resolve)
				}
			},
			'/word15': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word15.vue'], resolve)
				}
			},
			'/word16': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word16.vue'], resolve)
				}
			},
			'/word17': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word17.vue'], resolve)
				}
			},
			'/word18': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word18.vue'], resolve)
				}
			},
			'/word19': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word19.vue'], resolve)
				}
			},
			'/word20': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word20.vue'], resolve)
				}
			},
			'/word21': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word21.vue'], resolve)
				}
			},
			'/word22': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word22.vue'], resolve)
				}
			},
			'/word23': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word23.vue'], resolve)
				}
			},
			'/word24': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word24.vue'], resolve)
				}
			},
			'/word25': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word25.vue'], resolve)
				}
			},
			'/word26': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word26.vue'], resolve)
				}
			},
			'/word27': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word27.vue'], resolve)
				}
			},
			'/word28': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word28.vue'], resolve)
				}
			},
			'/word29': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word29.vue'], resolve)
				}
			},
			'/word30': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/word30.vue'], resolve)
				}
			},
			'/news': {
				back: true,
				component: function(resolve) {
					require(['./components/retreat/news.vue'], resolve)
				},
				subRoutes: {
					'/guide': {
						component: function(resolve) {
							require(['./components/retreat/guide.vue'], resolve)
						},
						subRoutes: {
							'/word': {
								component: function(resolve) {
									require(['./components/retreat/word.vue'], resolve)
								}
							}
						}
					},
					'/word': {
						component: function(resolve) {
							require(['./components/retreat/word.vue'], resolve)
						}
					},
					'/word2': {
						component: function(resolve) {
							require(['./components/retreat/word2.vue'], resolve)
						}
					},
					'/word3': {
						component: function(resolve) {
							require(['./components/retreat/word3.vue'], resolve)
						}
					},
					'/word4': {
						component: function(resolve) {
							require(['./components/retreat/word4.vue'], resolve)
						}
					},
					'/word5': {
						component: function(resolve) {
							require(['./components/retreat/word5.vue'], resolve)
						}
					},
					'/word6': {
						component: function(resolve) {
							require(['./components/retreat/word6.vue'], resolve)
						}
					},
					'/word7': {
						component: function(resolve) {
							require(['./components/retreat/word7.vue'], resolve)
						}
					},
					'/word8': {
						component: function(resolve) {
							require(['./components/retreat/word8.vue'], resolve)
						}
					},
					'/word9': {
						component: function(resolve) {
							require(['./components/retreat/word9.vue'], resolve)
						}
					},
					'/word10': {
						component: function(resolve) {
							require(['./components/retreat/word10.vue'], resolve)
						}
					},
					'/word11': {
						component: function(resolve) {
							require(['./components/retreat/word11.vue'], resolve)
						}
					},
					'/word12': {
						component: function(resolve) {
							require(['./components/retreat/word12.vue'], resolve)
						}
					},
					'/word13': {
						component: function(resolve) {
							require(['./components/retreat/word13.vue'], resolve)
						}
					},
					'/word14': {
						component: function(resolve) {
							require(['./components/retreat/word14.vue'], resolve)
						}
					},
					'/word15': {
						component: function(resolve) {
							require(['./components/retreat/word15.vue'], resolve)
						}
					},
					'/word16': {
						component: function(resolve) {
							require(['./components/retreat/word16.vue'], resolve)
						}
					},
					'/word17': {
						component: function(resolve) {
							require(['./components/retreat/word17.vue'], resolve)
						}
					},
					'/word18': {
						component: function(resolve) {
							require(['./components/retreat/word18.vue'], resolve)
						}
					},
					'/word19': {
						component: function(resolve) {
							require(['./components/retreat/word19.vue'], resolve)
						}
					},
					'/word20': {
						component: function(resolve) {
							require(['./components/retreat/word20.vue'], resolve)
						}
					},
					'/word21': {
						component: function(resolve) {
							require(['./components/retreat/word21.vue'], resolve)
						}
					},
					'/word22': {
						component: function(resolve) {
							require(['./components/retreat/word22.vue'], resolve)
						}
					},
					'/word23': {
						component: function(resolve) {
							require(['./components/retreat/word23.vue'], resolve)
						}
					},
					'/word24': {
						component: function(resolve) {
							require(['./components/retreat/word24.vue'], resolve)
						}
					},
					'/word25': {
						component: function(resolve) {
							require(['./components/retreat/word25.vue'], resolve)
						}
					},
					'/word26': {
						component: function(resolve) {
							require(['./components/retreat/word26.vue'], resolve)
						}
					},
					'/word27': {
						component: function(resolve) {
							require(['./components/retreat/word27.vue'], resolve)
						}
					},
					'/word28': {
						component: function(resolve) {
							require(['./components/retreat/word28.vue'], resolve)
						}
					},
					'/word29': {
						component: function(resolve) {
							require(['./components/retreat/word29.vue'], resolve)
						}
					},
					'/word30': {
						component: function(resolve) {
							require(['./components/retreat/word30.vue'], resolve)
						}
					},
					'/notice': {
						component: function(resolve) {
							require(['./components/retreat/notice.vue'], resolve)
						}
					}
				}
			}
		}
	},
	'/products': {
		component: function(resolve) {
			require(['./components/products/product.vue'], resolve)
		},
		subRoutes: {
			'/type': {
				back: true,
				component: function(resolve) {
					require(['./components/products/type.vue'], resolve)
				},
				subRoutes: {
					'/view': {
						back: true,
						component: function(resolve) {
							require(['./components/products/view.vue'], resolve)
						},
						subRoutes: {
							'/contract': {
								back: true,
								component: function(resolve) {
									require(['./components/public/contract.vue'], resolve)
								}
							},
							'/charge': {
								back: true,
								component: function(resolve) {
									require(['./components/contract/charge.vue'], resolve)
								}
							},
							'/success': {
								back: '/user',
								component: function(resolve) {
									require(['./components/pay/success.vue'], resolve)
								}
							}
						}
					}
				}
			},
			'/invest': {
				limits: 'bankdeposit',
				back: true,
				component: function(resolve) {
					require(['./components/pay/invest.vue'], resolve)
				},
				subRoutes: {
					'/confirm': {
						back: true,
						component: function(resolve) {
							require(['./components/pay/confirm.vue'], resolve)
						},
						subRoutes: {
							'/success': {
								back: '/user',
								component: function(resolve) {
									require(['./components/pay/success.vue'], resolve)
								}
							},
							'/charge': {
								back: true,
								component: function(resolve) {
									require(['./components/contract/charge.vue'], resolve)
								},
								subRoutes: {
									'/focus': {
										back: true,
										component: function(resolve) {
											require(['./components/contract/focus.vue'], resolve)
										},
										subRoutes: {
											'/contract': {
												back: true,
												component: function(resolve) {
													require(['./components/public/contract.vue'], resolve)
												}
											}
										}
									}
								}
							},
							'/contract': {
								back: true,
								component: function(resolve) {
									require(['./components/public/contract.vue'], resolve)
								}
							},
							'/appraisal': {
								back: true,
								component: function(resolve) {
									require(['./components/appraisal/appraisal.vue'], resolve)
								}
							},
							'/type': {
								back: true,
								component: function(resolve) {
									require(['./components/products/type.vue'], resolve)
								},
								subRoutes: {
									'/view': {
										back: true,
										component: function(resolve) {
											require(['./components/products/view.vue'], resolve)
										},
										subRoutes: {
											'/contract': {
												back: true,
												component: function(resolve) {
													require(['./components/public/contract.vue'], resolve)
												}
											},
											'/charge': {
												back: true,
												component: function(resolve) {
													require(['./components/contract/charge.vue'], resolve)
												}
											},
											'/success': {
												back: '/user',
												component: function(resolve) {
													require(['./components/pay/success.vue'], resolve)
												}
											}
										}
									}
								}
							}
						}
					}
				}
			},
			'/view': {
				back: true,
				component: function(resolve) {
					require(['./components/products/view.vue'], resolve)
				},
				subRoutes: {
					'/contract': {
						back: true,
						component: function(resolve) {
							require(['./components/public/contract.vue'], resolve)
						}
					},
					'/charge': {
						back: true,
						component: function(resolve) {
							require(['./components/contract/charge.vue'], resolve)
						}
					},
					'/success': {
						back: '/user',
						component: function(resolve) {
							require(['./components/pay/success.vue'], resolve)
						}
					}
				}
			}
		}
	},
	'/find': {
		component: function(resolve) {
			require(['./components/find/find.vue'], resolve)
		},
		subRoutes: {
			'/vip': {
				back: true,
				component: function(resolve) {
					require(['./components/account/vips.vue'], resolve)
				},
				subRoutes: {
					'/lottery': {
						back: true,
						component: function(resolve) {
							require(['./components/account/lottery.vue'], resolve)
						},
						subRoutes: {
							'/lotteryrule': {
								back: true,
								component: function(resolve) {
									require(['./components/account/lotteryrule.vue'], resolve)
								}
							},
							'/lotteryhelp': {
								back: true,
								component: function(resolve) {
									require(['./components/account/lotteryhelp.vue'], resolve)
								}
							},
							'/lotterylist': {
								back: true,
								component: function(resolve) {
									require(['./components/account/lotterylist.vue'], resolve)
								}
							}
						}
					},
					'/signin': {
						back: true,
						component: function(resolve) {
							require(['./components/account/signin.vue'], resolve)
						},
						subRoutes: {
							'/questions': {
								back: true,
								component: function(resolve) {
									require(['./components/questions/questions.vue'], resolve)
								}
							},
							'/share': {
								back: true,
								component: function(resolve) {
									require(['./components/public/share.vue'], resolve)
								}
							}
						}
					},
					'/invite': {
						back: true,
						component: function(resolve) {
							require(['./components/account/invite.vue'], resolve)
						},
						subRoutes: {
							'/invitelist': {
								back: true,
								component: function(resolve) {
									require(['./components/account/invitelist.vue'], resolve)
								}
							},
							'/cash': {
								back: true,
								component: function(resolve) {
									require(['./components/account/cash.vue'], resolve)
								}
							},
							'/inviterule': {
								back: true,
								component: function(resolve) {
									require(['./components/account/inviterule.vue'], resolve)
								}
							}
						}
					},
					'/leval': {
						back: true,
						component: function(resolve) {
							require(['./components/account/vip.vue'], resolve)
						},
						subRoutes: {
							'/lotterylist': {
								back: true,
								component: function(resolve) {
									require(['./components/account/lotterylist.vue'], resolve)
								}
							},
							'/viprule': {
								back: true,
								component: function(resolve) {
									require(['./components/account/viprule.vue'], resolve)
								}
							},
							'/appraisal': {
								back: true,
								component: function(resolve) {
									require(['./components/appraisal/appraisal.vue'], resolve)
								}
							}
						}
					},
					'/groups': {
						back: true,
						component: function(resolve) {
							require(['./components/group/group.vue'], resolve)
						}
					}
				}
			},
			'/invite': {
				back: true,
				component: function(resolve) {
					require(['./components/account/invite.vue'], resolve)
				},
				subRoutes: {
					'/invitelist': {
						back: true,
						component: function(resolve) {
							require(['./components/account/invitelist.vue'], resolve)
						}
					},
					'/cash': {
						back: true,
						component: function(resolve) {
							require(['./components/account/cash.vue'], resolve)
						}
					},
					'/inviterule': {
						back: true,
						component: function(resolve) {
							require(['./components/account/inviterule.vue'], resolve)
						}
					}
				}
			},
			'/lottery': {
				back: true,
				component: function(resolve) {
					require(['./components/account/lottery.vue'], resolve)
				},
				subRoutes: {
					'/lotteryrule': {
						back: true,
						component: function(resolve) {
							require(['./components/account/lotteryrule.vue'], resolve)
						}
					},
					'/lotteryhelp': {
						back: true,
						component: function(resolve) {
							require(['./components/account/lotteryhelp.vue'], resolve)
						}
					},
					'/lotterylist': {
						back: true,
						component: function(resolve) {
							require(['./components/account/lotterylist.vue'], resolve)
						}
					}
				}
			},
			'/signin': {
				back: true,
				component: function(resolve) {
					require(['./components/account/signin.vue'], resolve)
				},
				subRoutes: {
					'/questions': {
						back: true,
						component: function(resolve) {
							require(['./components/questions/questions.vue'], resolve)
						}
					},
					'/share': {
						back: true,
						component: function(resolve) {
							require(['./components/public/share.vue'], resolve)
						}
					}
				}
			},
			'/appraisaltip': {
				back: true,
				component: function(resolve) {
					require(['./components/appraisal/appraisaltip.vue'], resolve)
				},
			},
			'/activity': {
				back: true,
				component: function(resolve) {
					require(['./components/activity/activity.vue'], resolve)
				},
				subRoutes: {
					'/view': {
						back: true,
						component: function(resolve) {
							require(['./components/activity/view.vue'], resolve)
						}
					}
				}
			},
			'/hotread': {
				back: true,
				component: function(resolve) {
					require(['./components/hotRead/hot.vue'], resolve)
				},
			},
			'/education': {
				back: true,
				component: function(resolve) {
					require(['./components/find/education.vue'], resolve)
				},
			},
			'/timevaluestory': {
				back: true,
				component: function(resolve) {
					require(['./components/find/timevaluestory.vue'], resolve)
				},
			},
			'/aboutus': {
				back: true,
				component: function(resolve) {
					require(['./components/find/aboutus.vue'], resolve)
				},
				subRoutes: {
					'/team': {
						back: true,
						component: function(resolve) {
							require(['./components/find/team.vue'], resolve)
						}
					},
					'/expert': {
						back: true,
						component: function(resolve) {
							require(['./components/find/expert.vue'], resolve)
						}
					},
					'/holder': {
						back: true,
						component: function(resolve) {
							require(['./components/find/holder.vue'], resolve)
						}
					},
					'/timeline': {
						back: true,
						component: function(resolve) {
							require(['./components/find/timeline.vue'], resolve)
						}
					},
					'/product': {
						back: true,
						component: function(resolve) {
							require(['./components/find/product.vue'], resolve)
						}
					}
				}
			},
			'/info': {
				back: true,
				component: function(resolve) {
					require(['./components/find/infos.vue'], resolve)
				},
				subRoutes: {
					'/bankdepositword': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositword.vue'], resolve)
						}
					},
					'/detail': {
						back: true,
						component: function(resolve) {
							require(['./components/public/view.vue'], resolve)
						}
					}
				}
			},
			'/investclass': {
				back: true,
				component: function(resolve) {
					require(['./components/find/investclass.vue'], resolve)
				},
				subRoutes: {
					'/bankdepositpic': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic.vue'], resolve)
						}
					},
					'/bankdepositpic2': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic2.vue'], resolve)
						}
					},
					'/bankdepositpic3': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic3.vue'], resolve)
						}
					},
					'/bankdepositpic4': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic4.vue'], resolve)
						}
					},
					'/bankdepositpic5': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic5.vue'], resolve)
						}
					},
					'/bankdepositpic6': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic6.vue'], resolve)
						}
					},
					'/bankdepositpic7': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic7.vue'], resolve)
						}
					}
				}
			},
			'/security': {
				back: true,
				component: function(resolve) {
					require(['./components/find/security.vue'], resolve)
				},
				subRoutes: {
					'/info': {
						back: true,
						component: function(resolve) {
							require(['./components/find/info.vue'], resolve)
						},
						subRoutes: {
							'/detail': {
								back: true,
								component: function(resolve) {
									require(['./components/public/view.vue'], resolve)
								}
							}
						}
					},
					'/privacy': {
						back: true,
						component: function(resolve) {
							require(['./components/contract/privacy.vue'], resolve)
						}
					}
				}
			},
			'/newmember': {
				back: true,
				component: function(resolve) {
					require(['./components/find/newmember.vue'], resolve)
				},
				subRoutes: {
					'/picture': {
						back: true,
						component: function(resolve) {
							require(['./components/find/picture.vue'], resolve)
						}
					},
					'/teach': {
						back: true,
						component: function(resolve) {
							require(['./components/find/teach.vue'], resolve)
						},
						subRoutes: {
							'/register': {
								back: true,
								component: function(resolve) {
									require(['./components/help/register.vue'], resolve)
								}
							},
							'/open': {
								back: true,
								component: function(resolve) {
									require(['./components/help/open.vue'], resolve)
								}
							},
							'/sign': {
								back: true,
								component: function(resolve) {
									require(['./components/help/sign.vue'], resolve)
								}
							},
							'/mobile': {
								back: true,
								component: function(resolve) {
									require(['./components/help/mobile.vue'], resolve)
								}
							},
							'/fast': {
								back: true,
								component: function(resolve) {
									require(['./components/help/fast.vue'], resolve)
								}
							},
							'/withdraw': {
								back: true,
								component: function(resolve) {
									require(['./components/help/withdraw.vue'], resolve)
								}
							},
							'/confirm': {
								back: true,
								component: function(resolve) {
									require(['./components/help/confirm.vue'], resolve)
								}
							},
						}
					},
					'/appraisal': {
						back: true,
						component: function(resolve) {
							require(['./components/appraisal/appraisal.vue'], resolve)
						}
					}
				}
			},
			'/bankdeposit': {
				back: true,
				component: function(resolve) {
					require(['./components/find/bankdeposit.vue'], resolve)
				},
				subRoutes: {
					'/bankdepositword': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositword.vue'], resolve)
						}
					},
					'/bankdepositpic': {
						back: true,
						component: function(resolve) {
							require(['./components/find/bankdepositpic.vue'], resolve)
						}
					}
				}
			},
			'/risk': {
				back: true,
				component: function(resolve) {
					require(['./components/find/risk.vue'], resolve)
				}
			},
			'/comment': {
				back: true,
				component: function(resolve) {
					require(['./components/find/comment.vue'], resolve)
				}
			},
			'/suggest': {
				back: true,
				component: function(resolve) {
					require(['./components/find/suggest.vue'], resolve)
				},
				subRoutes: {
					'/list': {
						back: true,
						component: function(resolve) {
							require(['./components/find/suggestlist.vue'], resolve)
						}
					}
				}
			}
			// '/commentlist':{
			//     back: '/find',
			//     component: function (resolve) {
			//         require(['./components/find/commentlist.vue'], resolve)
			//     },
			//     subRoutes: {
			//         '/edit':{
			//             back: true,
			//             component: function (resolve) {
			//                 require(['./components/find/comment.vue'], resolve)
			//             }
			//         }
			//     }
			// }
		}
	},
	'/help': {
		component: function(resolve) {
			require(['./components/help/help.vue'], resolve)
		},
		subRoutes: {
			'/logintoregister': {
				back: true,
				component: function(resolve) {
					require(['./components/help/logintoregister.vue'], resolve)
				}
			},
			'/openanaccount': {
				back: true,
				component: function(resolve) {
					require(['./components/help/openanaccount.vue'], resolve)
				}
			},
			'/recharge': {
				back: true,
				component: function(resolve) {
					require(['./components/help/recharge.vue'], resolve)
				}
			},
			'/investment': {
				back: true,
				component: function(resolve) {
					require(['./components/help/investment.vue'], resolve)
				}
			},
			'/assets': {
				back: true,
				component: function(resolve) {
					require(['./components/help/assets.vue'], resolve)
				}
			},
			'/withdrawal': {
				back: true,
				component: function(resolve) {
					require(['./components/help/withdrawal.vue'], resolve)
				}
			},
			'/yields': {
				back: true,
				component: function(resolve) {
					require(['./components/help/yields.vue'], resolve)
				}
			},
			'/reward': {
				back: true,
				component: function(resolve) {
					require(['./components/help/reward.vue'], resolve)
				}
			},
			'/bankdepository': {
				back: true,
				component: function(resolve) {
					require(['./components/help/bankdepository.vue'], resolve)
				}
			},
			'/risk': {
				back: true,
				component: function(resolve) {
					require(['./components/help/risk.vue'], resolve)
				}
			},
			'/about': {
				back: true,
				component: function(resolve) {
					require(['./components/help/about.vue'], resolve)
				}
			},
			'/productadvantage': {
				back: true,
				component: function(resolve) {
					require(['./components/help/productadvantage.vue'], resolve)
				}
			},
			'/wechat': {
				back: true,
				component: function(resolve) {
					require(['./components/help/wechat.vue'], resolve)
				}
			}
		}
	},
	'/reset': {
		back: true,
		component: function(resolve) {
			require(['./components/reset/resetpass.vue'], resolve)
		},
		subRoutes: {
			'/reset2': {
				back: true,
				component: function(resolve) {
					require(['./components/reset/resetpass2.vue'], resolve)
				},
				subRoutes: {
					'/pswsuccess': {
						back: '/login',
						component: function(resolve) {
							require(['./components/success/pswsuccess.vue'], resolve)
						}
					},
				}
			},
		}
	},

	'/system': {
		back: '/user',
		component: function(resolve) {
			require(['./components/system/system.vue'], resolve)
		},
		subRoutes: {
			'/appraisal': {
				back: true,
				component: function(resolve) {
					require(['./components/appraisal/appraisal.vue'], resolve)
				}
			},
			'/paswordchange': {
				back: true,
				component: function(resolve) {
					require(['./components/system/paswordchange.vue'], resolve)
				},
				subRoutes: {
					'/fingerprint': {
						back: true,
						component: function(resolve) {
							require(['./components/system/fingerprint.vue'], resolve)
						}
					}
				}
			},
			'/log': {
				back: true,
				component: function(resolve) {
					require(['./components/system/log.vue'], resolve)
				}
			},
			'/getmoney': {
				back: true,
				component: function(resolve) {
					require(['./components/system/getMoney.vue'], resolve)
				}
			},
			'/gesture': {
				back: true,
				component: function(resolve) {
					require(['./components/reset/gesture.vue'], resolve)
				}
			},
			'/card': {
				back: '/system',
				limits: 'bankdeposit',
				skipsign: true,
				component: function(resolve) {
					require(['./components/account/card.vue'], resolve)
				},
				subRoutes: {
					// '/operation': {
					//     back: true,
					//     component: function (resolve) {
					//         require(['./components/card/operation.vue'], resolve)
					//     },
					//     subRoutes: {

					//         '/bindoperation': {
					//             component: function (resolve) {
					//                 require(['./components/system/bindoperation.vue'], resolve)
					//             },
					//             subRoutes:{
					//             	'/banking': {
					//               component: function (resolve) {
					//                   require(['./components/system/banking.vue'], resolve)
					//               }
					//           },
					//             }
					//         },
					//         '/changeoperation': {
					//             component: function (resolve) {
					//                 require(['./components/system/changeoperation.vue'], resolve)
					//             },
					//             subRoutes:{
					//             	'/banking': {
					//               component: function (resolve) {
					//                   require(['./components/system/banking.vue'], resolve)
					//               }
					//           },
					//             }
					//         }

					//     }
					// }
					'/banking': {
						component: function(resolve) {
							require(['./components/system/banking.vue'], resolve)
						}
					},
					'/bindoperation': {
						component: function(resolve) {
							require(['./components/system/bindoperation.vue'], resolve)
						},
						subRoutes: {
							'/banking': {
								component: function(resolve) {
									require(['./components/system/banking.vue'], resolve)
								}
							},
						}
					},
					'/changeoperation': {
						component: function(resolve) {
							require(['./components/system/changeoperation.vue'], resolve)
						},
						subRoutes: {
							'/banking': {
								component: function(resolve) {
									require(['./components/system/banking.vue'], resolve)
								}
							},
						}
					}
				}
			},
			'/invest': {
				back: true,
				component: function(resolve) {
					require(['./components/system/invest.vue'], resolve)
				}
				// subRoutes: {
				//     '/type':{
				//         back: true,
				//         component: function (resolve) {
				//             require(['./components/products/type.vue'], resolve)
				//         },
				//         subRoutes: {
				//             '/view':{
				//                 back: true,
				//                 component: function (resolve) {
				//                     require(['./components/products/view.vue'], resolve)
				//                 },
				//                 subRoutes: {
				//                     '/contract': {
				//                         back: true,
				//                         component: function (resolve) {
				//                             require(['./components/public/contract.vue'], resolve)
				//                         }
				//                     }
				//                 }
				//             }
				//         }
				//     }
				// }
			},
			// '/version':{
			//     back: true,
			//     component: function (resolve) {
			//         require(['./components/system/version.vue'], resolve)
			//     }
			// },
			'/personal': {
				back: true,
				component: function(resolve) {
					require(['./components/personal/personal.vue'], resolve)
				},
				subRoutes: {
					'/headimg': {
						back: true,
						component: function(resolve) {
							require(['./components/personal/headimg.vue'], resolve)
						}
					},
					'/mobile': {
						back: true,
						component: function(resolve) {
							require(['./components/personal/resetmobile.vue'], resolve)
						},
						subRoutes: {
							'/mobile2': {
								back: true,
								component: function(resolve) {
									require(['./components/personal/resetmobile2.vue'], resolve)
								},
								subRoutes: {
									'/mobilesuccess': {
										back: '/user',
										component: function(resolve) {
											require(['./components/success/mobile.vue'], resolve)
										}
									}
								}
							},
							'/confirm': {
								back: true,
								component: function(resolve) {
									require(['./components/personal/mobileconfirm.vue'], resolve)
								},
								subRoutes: {
									'/banking': {
										component: function(resolve) {
											require(['./components/system/banking.vue'], resolve)
										}
									}
								}
							}
						}
					},
                    '/bankmobile': {
                        back: true,
                        component: function(resolve) {
                            require(['./components/personal/bankmobile.vue'], resolve)
                        },
                        subRoutes: {
                            '/banking': {
                                component: function(resolve) {
                                    require(['./components/system/banking.vue'], resolve)
                                }
                            }
                        }
                    },
					'/qrcode': {
						back: true,
						component: function(resolve) {
							require(['./components/personal/qrcode.vue'], resolve)
						}
					},
					'/wechat': {
						back: true,
						component: function(resolve) {
							require(['./components/personal/wechat.vue'], resolve)
						}
					},
					'/address': {
						back: true,
						component: function(resolve) {
							require(['./components/personal/address.vue'], resolve)
						},
						subRoutes: {
							'/edit': {
								name: "edit",
								back: true,
								component: function(resolve) {
									require(['./components/personal/editaddress.vue'], resolve)
								}
							}
						}
					},
					'/inovance': {
						back: true,
						component: function(resolve) {
							require(['./components/personal/inovance.vue'], resolve)
						}
					}
				}
			},
		}
	},
	// '/bank': {
	//     back: true,
	//     component: function (resolve) {
	//         require(['./components/bank/bank1.vue'], resolve)
	//     },
	//     subRoutes: {
	//         '/view': {
	//             back: true,
	//             component: function (resolve) {
	//                 require(['./components/bank/bank2.vue'], resolve)
	//             },
	//             subRoutes: {
	//                 '/success': {
	//                     back: true,
	//                     component: function (resolve) {
	//                         require(['./components/bank/success.vue'], resolve)
	//                     },
	//                     subRoutes: {
	//                         '/banking': {
	//                             component: function (resolve) {
	//                                 require(['./components/system/banking.vue'], resolve)
	//                             }
	//                         }
	//                     }
	//                 }
	//             }
	//         },
	//         '/contract': {
	//             back: true,
	//             component: function (resolve) {
	//                 require(['./components/public/contract.vue'], resolve)
	//             }
	//         }
	//     }
	// },
	'/banks': {
		back: true,
		component: function(resolve) {
			require(['./components/bank/bank3.vue'], resolve)
		},
		subRoutes: {
			'/contract': {
				back: true,
				component: function(resolve) {
					require(['./components/public/contract.vue'], resolve)
				}
			}
		}
	},
	// '/signbid': {
	//     back: true,
	//     component: function (resolve) {
	//         require(['./components/sign/sign1.vue'], resolve)
	//     },
	//     subRoutes: {
	//         '/banking': {
	//             component: function (resolve) {
	//                 require(['./components/system/banking.vue'], resolve)
	//             }
	//         }
	//     }
	// },
	// '/signcredit': {
	//     back: true,
	//     component: function (resolve) {
	//         require(['./components/sign/sign2.vue'], resolve)
	//     },
	//     subRoutes: {
	//         '/banking': {
	//             component: function (resolve) {
	//                 require(['./components/system/banking.vue'], resolve)
	//             }
	//         }
	//     }
	// },
	// '/signbids': {
	//     back: true,
	//     component: function (resolve) {
	//         require(['./components/sign/signs1.vue'], resolve)
	//     },
	//     subRoutes: {
	//         '/banking': {
	//             component: function (resolve) {
	//                 require(['./components/system/banking.vue'], resolve)
	//             }
	//         }
	//     }
	// },
	// '/signcredits': {
	//     back: true,
	//     component: function (resolve) {
	//         require(['./components/sign/signs2.vue'], resolve)
	//     },
	//     subRoutes: {
	//         '/banking': {
	//             component: function (resolve) {
	//                 require(['./components/system/banking.vue'], resolve)
	//             }
	//         }
	//     }
	// },
	'/signall': {
		back: true,
		component: function(resolve) {
			require(['./components/sign/signall.vue'], resolve)
		},
		subRoutes: {
			'/banking': {
				component: function(resolve) {
					require(['./components/system/banking.vue'], resolve)
				}
			}
		}
	},
	'/login': {
		back: '/index',
		component: function(resolve) {
			require(['./components/login/login.vue'], resolve)
		},
		subRoutes: {
			// '/reset': {
			// 	back: true,
			// 	component: function(resolve) {
			// 		require(['./components/reset/resetpass.vue'], resolve)
			// 	}
			// },
			'/gesture': {
				back: '/user',
				component: function(resolve) {
					require(['./components/public/gesture.vue'], resolve)
				}
			}
		}
	},
	'/verify': {
		back: '/index',
		component: function(resolve) {
			require(['./components/public/verify.vue'], resolve)
		},
		subRoutes: {
			'/verifycode': {
				back: true,
				component: function(resolve) {
					require(['./components/public/verifycode.vue'], resolve)
				}
			}
		}
	},
	'/register': {
		back: true,
		component: function(resolve) {
			require(['./components/register/register1.vue'], resolve)
		},
		subRoutes: {
			'/contract': {
				back: true,
				component: function(resolve) {
					require(['./components/public/contract.vue'], resolve)
				}
			},
			'/setpass': {
				back: true,
				component: function(resolve) {
					require(['./components/register/register2.vue'], resolve)
				},
				subRoutes: {
					'/success': {
						back: '/user',
						component: function(resolve) {
							require(['./components/register/success.vue'], resolve)
						}
					}
				}
			}
		}
	},
	'/newer': {
		back: '/user',
		component: function(resolve) {
			require(['./components/newer/newer.vue'], resolve)
		},
		subRoutes: {
			'/detail': {
				back: true,
				component: function(resolve) {
					require(['./components/newer/detail.vue'], resolve)
				},
				subRoutes: {
					'/intro': {
						back: true,
						component: function(resolve) {
							require(['./components/newer/intro.vue'], resolve)
						}
					},
					'/midautumn': {
						back: true,
						component: function(resolve) {
							require(['./components/newer/midautumn.vue'], resolve)
						}
					},
				}
			}
		}
	},
	'/invites': {
		back: '/user',
		component: function(resolve) {
			require(['./components/invites/invites.vue'], resolve)
		},
		subRoutes: {
			'/invitelist': {
				back: true,
				component: function(resolve) {
					require(['./components/account/invitelist.vue'], resolve)
				}
			},
			'/cash': {
				back: true,
				component: function(resolve) {
					require(['./components/account/cash.vue'], resolve)
				}
			}
		}
	},
	'/withdrawsuccess': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/withdraw.vue'], resolve)
		}
	},
	'/retreatwithdrawsuccess': {
		back: '/retreat',
		component: function(resolve) {
			require(['./components/success/retreatwithdraw.vue'], resolve)
		}
	},
	'/fastsuccess': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/fastsuccess.vue'], resolve)
		}
	},
	'/fastfail': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/fastfail.vue'], resolve)
		}
	},
	'/opensuccess': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/open.vue'], resolve)
		}
	},
	'/signsuccess': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/sign.vue'], resolve)
		}
	},
	'/signstatus': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/signstatus.vue'], resolve)
		}
	},
	'/bindcardsuccess': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/bindcard.vue'], resolve)
		}
	},
	'/unbindcardsuccess': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/unbindcard.vue'], resolve)
		}
	},
	'/resetsuccess': {
		back: '/system',
		component: function(resolve) {
			require(['./components/success/setpass.vue'], resolve)
		}
	},
    '/mobilesuccess': {
        back: '/user',
        component: function(resolve) {
            require(['./components/success/mobile.vue'], resolve)
        }
    },
	'/bankstatus': {
		back: '/user',
		component: function(resolve) {
			require(['./components/success/bankstatus.vue'], resolve)
		},
		subRoutes: {
			'/banking': {
				component: function(resolve) {
					require(['./components/system/banking.vue'], resolve)
				}
			}
		}
	},
	'/news': {
		back: true,
		component: function(resolve) {
			require(['./components/news/news.vue'], resolve)
		},
		subRoutes: {
			'/accountnews': {
				back: true,
				component: function(resolve) {
					require(['./components/news/accountnews.vue'], resolve)
				},
				subRoutes: {
					'/detail': {
						back: true,
						component: function(resolve) {
							require(['./components/news/detaila.vue'], resolve)
						},
						subRoutes: {
							'/trans': {
								back: true,
								component: function(resolve) {
									require(['./components/news/trans.vue'], resolve)
								},
								subRoutes: {
									'/view': {
										back: true,
										component: function(resolve) {
											require(['./components/products/view.vue'], resolve)
										},
										subRoutes: {
											'/contract': {
												back: true,
												component: function(resolve) {
													require(['./components/public/contract.vue'], resolve)
												}
											},
											'/success': {
												back: '/user',
												component: function(resolve) {
													require(['./components/pay/success.vue'], resolve)
												}
											}
										}
									},
									'/contract': {
										back: true,
										component: function(resolve) {
											require(['./components/public/contract.vue'], resolve)
										}
									}
								}
							},
							'/prepareinvest': {
								back: true,
								component: function(resolve) {
									require(['./components/news/prepareinvest.vue'], resolve)
								}
							}
						}
					}
				}
			},
			'/activitynews': {
				back: true,
				component: function(resolve) {
					require(['./components/activity/activity.vue'], resolve)
				},
				subRoutes: {
					'/view': {
						back: true,
						component: function(resolve) {
							require(['./components/activity/view.vue'], resolve)
						}
					}
				}
			},
			'/noticenews': {
				back: true,
				component: function(resolve) {
					require(['./components/news/noticenews.vue'], resolve)
				},
				subRoutes: {
					'/detail': {
						back: true,
						component: function(resolve) {
							require(['./components/find/detail.vue'], resolve)
						}
					}
				}
			}
		}
	},
	//     '/activity': {
	//         back: true,
	//         component: function (resolve) {
	//             require(['./components/activity/activity.vue'], resolve)
	//         },
	//         subRoutes: {
	//             '/view': {
	//                 back: true,
	//                 component: function (resolve) {
	//                     require(['./components/activity/view.vue'], resolve)
	//                 }
	//             }
	//         }
	//     },
	'/replace1': {
		back: true,
		component: function(resolve) {
			require(['./components/card/replace1.vue'], resolve)
		},
		subRoutes: {
			'/replace2': {
				back: true,
				component: function(resolve) {
					require(['./components/card/replace2.vue'], resolve)
				},
				subRoutes: {
					'/replace3': {
						back: true,
						component: function(resolve) {
							require(['./components/card/replace3.vue'], resolve)
						},
						subRoutes: {
							'/replace4': {
								back: true,
								component: function(resolve) {
									require(['./components/card/replace4.vue'], resolve)
								},
								subRoutes: {
									'/replace5': {
										back: '/account/card/operation',
										component: function(resolve) {
											require(['./components/card/replace5.vue'], resolve)
										}
									}
								}
							}
						}
					}
				}
			}
		}
	},
	'/remobile1': {
		back: true,
		component: function(resolve) {
			require(['./components/card/remobile1.vue'], resolve)
		},
		subRoutes: {
			'/remobile2': {
				back: true,
				component: function(resolve) {
					require(['./components/card/remobile2.vue'], resolve)
				},
				subRoutes: {
					'/remobile3': {
						back: true,
						component: function(resolve) {
							require(['./components/card/remobile3.vue'], resolve)
						},
						subRoutes: {
							'/remobile4': {
								back: true,
								component: function(resolve) {
									require(['./components/card/remobile4.vue'], resolve)
								},
								subRoutes: {
									'/remobile5': {
										back: '/account/card/operation',
										component: function(resolve) {
											require(['./components/card/remobile5.vue'], resolve)
										}
									}
								}
							}
						}
					}
				}
			}
		}
	},
	'/unbundling1': {
		back: true,
		component: function(resolve) {
			require(['./components/card/unbundling1.vue'], resolve)
		},
		subRoutes: {
			'/unbundling2': {
				back: true,
				component: function(resolve) {
					require(['./components/card/unbundling2.vue'], resolve)
				},
				subRoutes: {
					'/unbundling3': {
						back: '/account/card/operation',
						component: function(resolve) {
							require(['./components/card/unbundling3.vue'], resolve)
						}
					}
				}
			}
		}
	},
	'/recharge': {
		back: true,
		component: function(resolve) {
			require(['./components/recharge/recharge.vue'], resolve)
		}
	},
	'/groups': {
		back: true,
		component: function(resolve) {
			require(['./components/group/group.vue'], resolve)
		}
	},
	'/wechats': {
		back: true,
		component: function(resolve) {
			require(['./components/personal/wechats.vue'], resolve)
		}
	},
	'/lottery': {
		back: '/user',
		component: function(resolve) {
			require(['./components/account/lotterys.vue'], resolve)
		},
		subRoutes: {
			'/lotteryrule': {
				back: true,
				component: function(resolve) {
					require(['./components/account/lotteryrule.vue'], resolve)
				}
			},
			'/lotteryhelp': {
				back: true,
				component: function(resolve) {
					require(['./components/account/lotteryhelp.vue'], resolve)
				}
			},
			'/lotterylist': {
				back: true,
				component: function(resolve) {
					require(['./components/account/lotterylist.vue'], resolve)
				}
			}
		}
	}
});

//默认/重定向到home页
Router.redirect({
	'/': "/index"
})
// if(window.plus){
//     if(plus.storage.getItem("loginTpye")){
//         Router.go({
//             path:"/login"
//         })
//     };
// }
//注册路由切换前
Router.beforeEach(function(transition) {
	transition.next();
})
//注册路由切换后
Router.afterEach(function(transition) {
	if(transition.to.limits) {
		window.limitTimer && clearTimeout(window.limitTimer);
		window.limitTimer = setTimeout(function() {
			timevalue.Ajax(timevalue.Api.userStatus, function(json) {
				if(transition.to.skipsign) {
					json.isSignBankAutoBid = 1;
					json.isSignBankAutoCredit = 1;
				};
				showBankDepositTips(json.isOpenBankAccount, json.isBindBankCard, json.isSetBankPass, json.isSignBankAutoBid, json.isSignBankAutoCredit);
			});
		}, 500)
	}
	Vue.nextTick(function(){
      try{
        $("input,select").blur(function(){

              setTimeout(() => {

                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;

                window.scrollTo(0, Math.max(scrollHeight - 1, 0));

              }, 100);

          })
      }catch(e){}
    })
})

Router.start(Enter, '#index');

//暴漏路由调试接口
window['Router'] = Router;


// WEBPACK FOOTER //
// ./src/main.js